import React from 'react';

import styled from 'styled-components';

import ActionLink from 'components/action-button';
import BrandIcon from 'components/brand-icon';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 90%;
  ${Styles.desktop`
    max-width: ${Styles.layout.smallerSectionMaxWidth};
  `}

  svg {
    fill: ${Styles.color.primary};
    width: 100px;
  }
`;

const Header = styled.h2`
  color: ${Styles.color.grey.one};
  font-family: ${Styles.fontFamily.base};
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 0;
  text-transform: uppercase;
`;

const Subheader = styled.p`
  margin: 1rem 0 2rem 0;
`;

interface IEmptyStateProps {
  header: string;
  subheader: string;
  linkText: string;
  linkTo: string;
}

const EmptyState = ({ header, subheader, linkText, linkTo }: IEmptyStateProps) => {
  return (
    <Container>
      <BrandIcon />
      <Header>{header}</Header>
      <Subheader>{subheader}</Subheader>
      <ActionLink to={linkTo}>{linkText}</ActionLink>
    </Container>
  );
};

export default EmptyState;
